import { SupportedCurrencyEnum } from '@goparrot/common';
import { FormatNumberOptions } from '@formatjs/intl/src/types';
import { getIntlNumber } from './getIntlNumber';

export const getIntlCurrency = (value: number, options: FormatNumberOptions = {}): string =>
  getIntlNumber(value, { style: 'currency', currency: SupportedCurrencyEnum.USD, ...options });
